import React, { useEffect, useRef, useState } from 'react';
import { Button, ISlideProps, Slide, Wrapper } from '../../index';

interface ISliderProps {
	slides: ISlideProps[];
	onFinished: () => void;
}
export const Slider = ({ slides, onFinished }: ISliderProps) => {
	const sliderRef = useRef<HTMLElement | null>(null);
	const [currentStep, setCurrentStep] = useState<number>(1);
	const [width, setWidth] = useState<number>(0);
	const [clientX, setClientX] = useState({ start: 0, end: 0 });

	const calculateStepSize = () => sliderRef.current && setWidth(sliderRef.current?.scrollWidth / slides.length);

	const nextStepHandler = (isBackwards = false) => {
		if (isBackwards) {
			if (currentStep === 1) {
				return;
			}
			setCurrentStep(Number(currentStep) - 1);
		} else {
			if (currentStep === slides.length) {
				return;
			}
			setCurrentStep(Number(currentStep) + 1);
		}
		sliderRef.current?.scrollTo({
			top: 0,
			left: isBackwards ? width * (currentStep - 2) : width * currentStep,
			behavior: 'smooth',
		});
	};

	const buttonClickHandler = () => {
		if (currentStep === slides.length) {
			onFinished();
			// router.push('/dkv/configure');
		} else {
			nextStepHandler();
		}
	};

	useEffect(() => {
		calculateStepSize();
		window.addEventListener('resize', calculateStepSize);
		return () => window.removeEventListener('resize', calculateStepSize);
	}, []);

	return (
		<>
			<Wrapper className="h-[calc(100vh_-_56px)] sm:h-[calc(100vh_-_98px)] bg-white" innerClass="justify-between">
				<section
					ref={sliderRef}
					className="flex overflow-hidden"
					onTouchStart={(e) => setClientX((prevState) => ({ ...prevState, start: e.touches[0].clientX }))}
					onTouchMove={(e) => setClientX((prevState) => ({ ...prevState, end: e.touches[0].clientX }))}
					onTouchEnd={() => {
						if (clientX.start - clientX.end > 100) {
							nextStepHandler();
						}
						if (clientX.end - clientX.start > 100) {
							nextStepHandler(true);
						}
					}}>
					{slides.map((slide, index) => (
						<Slide
							key={index}
							step={index + 1}
							image={slide.image}
							title={slide.title}
							description={slide.description}
						/>
					))}
				</section>
				<div className="flex justify-center items-center gap-1.75">
					{slides.map((_, index) => (
						<div
							key={index}
							className={`w-1.75 h-1.75 rounded-half ${
								index + 1 === currentStep ? 'bg-primary' : 'bg-gray-600'
							}`}
						/>
					))}
				</div>
			</Wrapper>
			<div className="sticky flex flex-col gap-6 bg-white bottom-0 left-0 right-0">
				<div className="p-1.5 border-solid border-l-0 border-b-0 border-r-0 border-t border-t-gray-600">
					<Button fullWidth className="mb-0" onClick={buttonClickHandler}>
						{currentStep < 4 ? 'Weiter' : "Los geht's"}
					</Button>
				</div>
			</div>
		</>
	);
};
